
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-construction-and-engineering",
      function () {
        return require("private-next-pages/industry-construction-and-engineering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-construction-and-engineering"])
      });
    }
  